module.exports = __webpack_public_path__ + "static/img/mingf12.3ba9d344.png";